import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cx } from "../../lib/format";

export const Pagination = ({ page, pages, buildHref }) => {
  if (pages <= 1) return null;
  const nums = Array.from({ length: pages }, (_, i) => i + 1).filter((n) => n === 1 || n === pages || Math.abs(n - page) <= 1);
  const out = [];
  nums.forEach((n, i) => { if (i && n - nums[i - 1] > 1) out.push("…"); out.push(n); });
  const btn = "inline-flex h-10 min-w-10 items-center justify-center rounded-full px-3 text-sm font-semibold transition-colors";
  return (
    <nav aria-label="Pagination" className="mt-12 flex items-center justify-center gap-1.5" data-testid="pagination">
      {page > 1 && <Link to={buildHref(page - 1)} className={cx(btn, "border border-ab-border bg-white hover:bg-ab-soft")} aria-label="Previous page" data-testid="pagination-prev"><ChevronLeft size={16} /></Link>}
      {out.map((n, i) => n === "…" ? <span key={`e${i}`} className="px-2 text-ab-muted">…</span> : (
        <Link key={n} to={buildHref(n)} aria-current={n === page ? "page" : undefined} data-testid={`pagination-page-${n}`} className={cx(btn, n === page ? "bg-ab-accent text-white" : "border border-ab-border bg-white hover:bg-ab-soft")}>{n}</Link>
      ))}
      {page < pages && <Link to={buildHref(page + 1)} className={cx(btn, "border border-ab-border bg-white hover:bg-ab-soft")} aria-label="Next page" data-testid="pagination-next"><ChevronRight size={16} /></Link>}
    </nav>
  );
};
